import React, { PureComponent } from "react";
export class DashboardSmallIcon extends PureComponent {
  render() {
    const { ...rest } = this.props;
    return (
      <svg width="16px" height="16px" viewBox="0 0 16 16" version="1.1" {...rest}>
        <title>Dashboard-14x14</title>
        <desc>Created with sketchtool.</desc>
        <defs></defs>
        <g id="Dashboard-16x16" stroke="none" fillRule="evenodd" strokeLinecap="square">
          <g id="dashboard-53" transform="translate(2.000000, 1.000000)" fill="#111111" stroke="none" {...rest}>
            <path d="M0,7.77777778 L6.22222222,7.77777778 L6.22222222,0 L0,0 L0,7.77777778 Z M0,14 L6.22222222,14 L6.22222222,9.33333333 L0,9.33333333 L0,14 Z M7.77777778,14 L14,14 L14,6.22222222 L7.77777778,6.22222222 L7.77777778,14 Z M7.77777778,0 L7.77777778,4.66666667 L14,4.66666667 L14,0 L7.77777778,0 Z" id="Shape"></path>
          </g>
        </g>
      </svg>
    );
  }
}
export default DashboardSmallIcon;



// WEBPACK FOOTER //
// ./src/_icons/DashboardSmallIcon/index.js